import { Component, ElementRef, Input, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';

@Component({
  selector: 'nc-carousel-list',
  templateUrl: './carousel-list.component.html',
  styleUrls: ['./carousel-list.component.less']
})
export class CarouselListComponent implements AfterViewInit, OnDestroy {
  @Input() ncTime: number = 1;//多少秒滚动一格
  @Input() ncRow: number = 1;//显示多少行
  liCount: number = 0;//计算
  liHeight: number = 0;//计算
  private observer!: MutationObserver;

  // 将事件处理函数定义为类的属性
  private handleMouseEnter = () => {
    const ul: HTMLElement = this.eleRef.nativeElement.querySelector('ul');
    if (!ul) return;
    ul.style.animationPlayState = 'paused';
    Array.from(ul.getElementsByTagName('li')).forEach(li => {
      li.style.animationPlayState = 'paused';
    });
  };

  private handleMouseLeave = () => {
    const ul: HTMLElement = this.eleRef.nativeElement.querySelector('ul');
    if (!ul) return;
    ul.style.animationPlayState = 'running';
    Array.from(ul.getElementsByTagName('li')).forEach(li => {
      li.style.animationPlayState = 'running';
    });
  };

  constructor(
    private eleRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit(): void {
    this.initializeCarousel();
    this.setupMutationObserver();
  }

  private initializeCarousel(): void {
    let ul: HTMLElement = this.eleRef.nativeElement.querySelector('ul');
    if (!ul) return;

    const liElements = Array.from(ul.getElementsByTagName('li')).filter(li => !li.classList.contains('cloned'));
    if (liElements.length === 0) return;

    this.liCount = liElements.length;
    this.liHeight = liElements[0].offsetHeight;
    this.ncRow = this.ncRow <= this.liCount ? this.ncRow : this.liCount;

    // 清除之前可能添加的克隆元素
    const clonedElements = ul.querySelectorAll('.cloned');
    clonedElements.forEach(el => el.remove());

    // 添加新的克隆元素
    let copy = liElements.slice(0, this.ncRow).map((li) => {
      const clonedLi = li.cloneNode(true) as HTMLElement;
      clonedLi.classList.add('cloned');
      return clonedLi;
    });
    copy.forEach(li => ul.appendChild(li));

    // 重置动画
    ul.style.animation = 'none';
    ul.offsetHeight; // 触发重排
    ul.style.animation = `move calc(${this.ncTime} * ${this.liCount} * 1s) steps(${this.liCount}) infinite`;

    // 重置所有 li 的动画
    const allLis = ul.getElementsByTagName('li');
    Array.from(allLis).forEach(li => {
      li.style.animation = 'none';
      li.offsetHeight; // 触发重排
      li.style.animation = `liMove calc(${this.ncTime} * 1s) infinite`;
    });

    // 先移除旧的事件监听器，再添加新的
    ul.removeEventListener('mouseenter', this.handleMouseEnter);
    ul.removeEventListener('mouseleave', this.handleMouseLeave);
    
    ul.addEventListener('mouseenter', this.handleMouseEnter);
    ul.addEventListener('mouseleave', this.handleMouseLeave);

    //在操作完 DOM 后调用 detectChanges() 确保变更被正确检测，防止下面的错误，用setTimeout的话该组件存在闪烁的问题
    //ERROR RuntimeError: NG0100: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: '0'. Current value: '5'.. Find more at https://angular.io/errors/NG0100
    this.cdr.detectChanges();
  }

  private setupMutationObserver(): void {
    const ul = this.eleRef.nativeElement.querySelector('ul');
    if (!ul) return;

    this.observer = new MutationObserver(() => {
      // console.log('数据发生变化');
      this.initializeCarousel();
    });

    this.observer.observe(ul, {
      // childList: true,//该项开启后非常卡顿，initializeCarousel会一直执行
      subtree: true,
      characterData: true
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    // 使用类属性中定义的事件处理函数来移除监听器
    const ul = this.eleRef.nativeElement.querySelector('ul');
    if (ul) {
      ul.removeEventListener('mouseenter', this.handleMouseEnter);
      ul.removeEventListener('mouseleave', this.handleMouseLeave);
    }
  }
}
